"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _StyleConfig = require("../utils/StyleConfig");
var _manifest_svg_icons = _interopRequireDefault(require("./manifest_svg_icons"));
var _helpers = require("./_helpers");
var _SvgIconSource = _interopRequireDefault(require("./_SvgIconSource"));
var _SvgIconConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-concur_android.css") : void 0);
var _SvgIconConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-concur_default.css") : void 0);
var _SvgIconConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-concur_gateway.css") : void 0);
var _SvgIconConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-concur_ios.css") : void 0);
var _SvgIconSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_fiori_3_dark.css") : void 0);
var _SvgIconSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_fiori_3_hcb.css") : void 0);
var _SvgIconSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_fiori_3_hcw.css") : void 0);
var _SvgIconSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_fiori_3.css") : void 0);
var _SvgIconSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_horizon_dark.css") : void 0);
var _SvgIconSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_horizon_hcb.css") : void 0);
var _SvgIconSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_horizon_hcw.css") : void 0);
var _SvgIconSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon-sap_horizon.css") : void 0);
var _excluded = ["ariaHidden", "className", "classNameMap", "iconName", "path1ClassName", "path2ClassName", "size", "title"]; // generated; see scripts/buildIconManifest.js
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _SvgIconConcur_android.default,
  concur_default: _SvgIconConcur_default.default,
  concur_gateway: _SvgIconConcur_gateway.default,
  concur_ios: _SvgIconConcur_ios.default,
  sap_fiori_3_dark: _SvgIconSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _SvgIconSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _SvgIconSap_fiori_3_hcw.default,
  sap_fiori_3: _SvgIconSap_fiori_.default,
  sap_horizon_dark: _SvgIconSap_horizon_dark.default,
  sap_horizon_hcb: _SvgIconSap_horizon_hcb.default,
  sap_horizon_hcw: _SvgIconSap_horizon_hcw.default,
  sap_horizon: _SvgIconSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-svg-icon';
var SvgIcon = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var ariaHidden = _ref.ariaHidden,
    className = _ref.className,
    classNameMap = _ref.classNameMap,
    iconName = _ref.iconName,
    path1ClassName = _ref.path1ClassName,
    path2ClassName = _ref.path2ClassName,
    size = _ref.size,
    title = _ref.title,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref2 = themeProviderContext || {},
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? 'concur_default' : _ref2$theme;
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, className);
  var path1Classes = classnames("".concat(CSS_BLOCK, "__path1"), "".concat(CSS_BLOCK, "__path1--").concat(iconName), path1ClassName);
  var path2Classes = classnames("".concat(CSS_BLOCK, "__path2"), "".concat(CSS_BLOCK, "__path2--").concat(iconName), path2ClassName);
  var iconSize = (0, _helpers.getIconPixelSize)(size, theme);
  var viewBox = (0, _helpers.getViewBox)(theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, otherProps, {
    role: !ariaHidden ? 'img' : undefined,
    "aria-hidden": !!ariaHidden,
    className: classes,
    height: iconSize,
    style: _objectSpread({
      enableBackground: "new ".concat(viewBox)
    }, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style),
    version: "1.1",
    viewBox: viewBox,
    width: iconSize,
    x: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    y: "0px",
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement(_SvgIconSource.default, {
    iconName: iconName,
    path1ClassName: path1Classes,
    path2ClassName: path2Classes,
    theme: theme
  }));
});
SvgIcon.displayName = 'SvgIcon';
SvgIcon.propTypes = {
  /** The name of the desired messaging icon */
  iconName: _propTypes.default.oneOf(_manifest_svg_icons.default).isRequired,
  /** The value for the `aria-hidden` attribute. Set to `true` when there
   * is already visible text explaining the **SvgIcon** or when
   * the **SvgIcon** is purely for decoration. */
  ariaHidden: _propTypes.default.bool,
  /** Custom classes to add to the **SvgIcon** component's tag. */
  className: _propTypes.default.string,
  /** Custom classes to add to an SVG's first path tag. */
  path1ClassName: _propTypes.default.string,
  /** Custom classes to add to an SVG's second path tag. */
  path2ClassName: _propTypes.default.string,
  /** **SvgIcon** size. Options are 'lg', 'lg-minus', 'md-plus', 'md',
   * 'md-minus', 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'. */
  size: _propTypes.default.oneOf(_StyleConfig.ICON_SIZES),
  /** Title text of the SVG for assistive technologies */
  title: _propTypes.default.string
};
SvgIcon.defaultProps = {
  size: 'sm'
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(SvgIcon);
exports.default = _default;